import { render, staticRenderFns } from "./OfertaMateriePrima.vue?vue&type=template&id=0ff85374&scoped=true"
import script from "./OfertaMateriePrima.vue?vue&type=script&lang=js"
export * from "./OfertaMateriePrima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff85374",
  null
  
)

export default component.exports